// GENERAL
import React, { useState } from "react";

// COMPONENTS
import {
	Section,
	PrimaryTable,
	BaseText,
	BaseButton,
	PrimaryButton,
} from "../../components";
import { CreateVendorItemModal } from "./view/index";

// HOOKS AND CONTEXTS
import usePageListDetails from "../../hooks/usePageListDetails";
import { PageDataProvider } from "../../hooks/usePageDataContext";
import { DataTableContextProvider } from "../../components/ui/Tables/hooks/useDataTableContext";

// UTILS
import { getFontAwesomeIcon } from "../../utils";

// TYPES
import { TableDisplayData } from "../../components/ui/Tables/types";

const VendorItemsPage: React.FC = () => {
	const [pageTitle, setPageTitle] = useState<string>("Vendor Items");
	const [hasModalTable, setHasModalTable] = useState<boolean>(true);
	const [data, setData] = useState<any[]>([]);
	const [isOpen, setIsOpen] = useState<boolean>(false);
	const { pageMeta } = usePageListDetails("vendor-items-listing");

	const [tableDisplayData, setTableDisplayData] = useState<TableDisplayData>({
		hasInfiniteScroll: false,
		leftLockedColumns: -1,
		isNestedTable: false,
		hasNestedTable: false,
		suffixColumnIndexes: [-1],
		tableSlug: "items",
		tableType: "primary",
		leftOffset: 219,
		hasCellExpansion: [],
	} as TableDisplayData);

	// checking the currentUser directly here
	const isOfficeDepotUser =
		localStorage.getItem("officeDepotUser") === "true";

	const showAddVendorButton = !isOfficeDepotUser;

	// apply the additional filter if this flag exists.
	const additionalData = [
		{ slug: "Items.catalogId", uuid: "1" },
		isOfficeDepotUser ? { slug: "vendorId", uuid: "1" } : "",
	];

	// Building Additional Data object
	const handleCreateVendorItemModalClick = () => {
		setIsOpen((prev) => !prev);
	};

	const modal = (
		<CreateVendorItemModal
			isOpen={isOpen}
			handleCreateVendorItemModalClick={handleCreateVendorItemModalClick}
		/>
	);

	const baseButtonClassNames =
		"text-sm bg-primary text-white px-4 flex items-center gap-2 hover:bg-primaryDefaultHover border-none font-omnes-medium";
	const containerClassNames = "pt-10 mx-[60px] h-full  font-omnes-regular";
	const sectionClassNames = "flex justify-between py-6";

	return (
		<div className={containerClassNames}>
			<Section additionalClasses={sectionClassNames}>
				<div className="flex items-center">
					{getFontAwesomeIcon("store", "solid")}
					<BaseText
						text={pageTitle}
						additionalClasses="pl-2"
						size="text-22px"
						color="text-navy-500"
						tag="h1"
						fontFamily="font-omnes-medium"
					/>
				</div>
				{showAddVendorButton && (
					<PrimaryButton
						icon={getFontAwesomeIcon("plus", "solid")}
						iconClasses="text-sm"
						text="Add Vendor Item"
						onClick={handleCreateVendorItemModalClick}
						additionalClasses={baseButtonClassNames}
					/>
				)}
			</Section>
			<PageDataProvider pageMeta={pageMeta} pageTitle={pageTitle}>
				<DataTableContextProvider
					showStickyColumn
					hasModalTable={false}
					data={data}
					rowsHaveModalOnClick={true}
				>
					<PrimaryTable
						pageTitle={pageTitle}
						hasModalTable={hasModalTable}
						setPageTitle={setPageTitle}
						setHasModalTable={setHasModalTable}
						slug={"vendor-items"}
						setData={setData}
						additionalData={additionalData}
						tableDisplayData={tableDisplayData}
					/>
				</DataTableContextProvider>
			</PageDataProvider>
			{modal}
		</div>
	);
};

export default VendorItemsPage;
